<template lang='pug' src='./Wrapper.pug'></template>

<script>
  import Calendar from '../Calendar/Calendar'
  import MenuCalendar from '../MenuCalendar/MenuCalendar'

  export default {
    name: 'Wrapper',
    components: {
      Calendar,
      MenuCalendar
    },
    data: function () {
      return {
        isHolidaysCalendar: true
      }
    }
  }
</script>

<style lang='css' src='./Wrapper.css' scoped></style>



// WEBPACK FOOTER //
// Wrapper.vue?f4508416